import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Tell tailwind-merge that the custom `fontSize` keys in tailwind.config.ts
// are font-size utilities, not text-color. Without this, `cn("text-white",
// "text-body-sm")` would collapse to just `text-body-sm` and silently drop
// the color.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'display',
            'display-lg',
            'h1',
            'h1-lg',
            'h2',
            'h2-lg',
            'h3',
            'h3-lg',
            'body',
            'body-lg',
            'body-sm',
            'label',
            'caption',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
